import { ClasseAtivo } from "./enum";

export default class Ativo implements IAtivo {
  public classeAtivo!: ClasseAtivo;
  public cnpj!: string;
  public cnpjAdm!: string;
  public codigoAtivo!: string;
  public codigoMercado!: string;
  public isin!: string;
  public mercado!: string;
  public nome!: string;
  public razaoSocial!: string;
  public razaoSocialAdm!: string;
  public segmento!: string;
  public setor!: string;
  public sigla4!: string;
  public subsetor!: string;

  constructor(param: IAtivo) {
    Object.assign(this, param);
  }

  public static conversorAtivo(ativo: any): Ativo {
    return new Ativo({
      classeAtivo: ativo.classe,
      cnpj: ativo.cnpj,
      cnpjAdm: ativo.cnpj_adm,
      codigoAtivo: ativo.sigla,
      codigoMercado: ativo.market_cod,
      isin: ativo.isin,
      mercado: ativo.market,
      nome: ativo.nome_pregao,
      razaoSocial: ativo.razao_social,
      razaoSocialAdm: ativo.razao_social_adm,
      segmento: ativo.segmento,
      setor: ativo.setor,
      sigla4: ativo.sigla4,
      subsetor: ativo.subsetor,
    });
  }
}

interface IAtivo {
  classeAtivo: ClasseAtivo;
  cnpj: string;
  cnpjAdm: string;
  codigoAtivo: string;
  codigoMercado: string;
  isin: string;
  mercado: string;
  nome: string;
  razaoSocial: string;
  razaoSocialAdm: string;
  segmento: string;
  setor: string;
  sigla4: string;
  subsetor: string;
}
